/* eslint-disable max-len */
const desktop = theme => {
  const {toVW} = theme;
  return {};
};

const mobile = theme => {
  const {toVW} = theme;

  return {
    blueGradientButton: {
      width: '100%',
      margin: '10px 0',
      height: 30,
      borderRadius: 10,
      color: 'white',
      border: 'none',
      background: 'linear-gradient(90deg, #33C4E8 0%, #4A65F2 100%)',
      boxShadow:
        '-5px -5px 10px 0px rgba(255, 255, 255, 0.05), 5px 5px 10px 0px rgba(0, 0, 0, 0.25), 1px 1px 1px 0px rgba(255, 255, 255, 0.25) inset',
      '&.ant-btn:hover, &.ant-btn:focus, &.ant-btn:active': {
        background: 'linear-gradient(90deg, #33C4E8 0%, #4A65F2 100%)',
        boxShadow:
          '-5px -5px 10px 0px rgba(255, 255, 255, 0.05), 5px 5px 10px 0px rgba(0, 0, 0, 0.25), 1px 1px 1px 0px rgba(255, 255, 255, 0.25) inset',
        filter: 'brightness(1.2)',
        border: 'none',
        color: 'white',
      },
      '&.ant-btn[disabled]': {
        background: 'linear-gradient(90deg, #33C4E8 0%, #4A65F2 100%)',
        boxShadow:
          '-5px -5px 10px 0px rgba(255, 255, 255, 0.05), 5px 5px 10px 0px rgba(0, 0, 0, 0.25), 1px 1px 1px 0px rgba(255, 255, 255, 0.25) inset',
        filter: 'brightness(0.5)',
        border: 'none',
        color: 'white',
      },
    },
    greyGradientButton: {
      extends: 'blueGradientButton',
      background: 'linear-gradient(90deg, #C5C5C5 0%, #818181 100%)',
      boxShadow:
        '-5px -5px 10px 0px rgba(255, 255, 255, 0.05), 5px 5px 10px 0px rgba(0, 0, 0, 0.25), 1px 1px 1px 0px rgba(255, 255, 255, 0.10) inset',
      '&.ant-btn': {
        '&.ant-btn:hover, &.ant-btn:focus, &.ant-btn:active': {
          background: 'linear-gradient(90deg, #C5C5C5 0%, #818181 100%)',
          boxShadow:
            '-5px -5px 10px 0px rgba(255, 255, 255, 0.05), 5px 5px 10px 0px rgba(0, 0, 0, 0.25), 1px 1px 1px 0px rgba(255, 255, 255, 0.10) inset',
          filter: 'brightness(1.2)',
          border: 'none',
          color: 'white',
        },
        '&.ant-btn[disabled]': {
          background: 'linear-gradient(90deg, #C5C5C5 0%, #818181 100%)',
          boxShadow:
            '-5px -5px 10px 0px rgba(255, 255, 255, 0.05), 5px 5px 10px 0px rgba(0, 0, 0, 0.25), 1px 1px 1px 0px rgba(255, 255, 255, 0.10) inset',
          filter: 'brightness(0.5)',
          border: 'none',
          color: 'white',
        },
      },
    },
    outlinedButton: {
      boxShadow:
        '-5px -5px 10px 0px rgba(255, 255, 255, 0.05), 5px 5px 10px 0px rgba(0, 0, 0, 0.25)',
      border: '1px solid #C7C9CC',
      color: '#C7C9CC',
      width: '100%',
      margin: '10px 0',
      height: 30,
      borderRadius: 10,
      background: 'transparent',
      '&.ant-btn:hover, &.ant-btn:focus, &.ant-btn:active': {
        background: 'transparent',
        boxShadow:
          '-5px -5px 10px 0px rgba(255, 255, 255, 0.05), 5px 5px 10px 0px rgba(0, 0, 0, 0.25)',
        filter: 'brightness(1.2)',
        border: '1px solid #C7C9CC',
        color: '#C7C9CC',
      },
      '&.ant-btn[disabled]': {
        background: 'transparent',
        boxShadow:
          '-5px -5px 10px 0px rgba(255, 255, 255, 0.05), 5px 5px 10px 0px rgba(0, 0, 0, 0.25)',
        filter: 'brightness(0.5)',
        border: '1px solid #C7C9CC',
        color: '#C7C9CC',
      },
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
